import { render, staticRenderFns } from "./RenderingConfigField.vue?vue&type=template&id=18530cf4&"
import script from "./RenderingConfigField.vue?vue&type=script&lang=js&"
export * from "./RenderingConfigField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports